import { ListPartnerMaterialsResponseSchema } from './list-partner-materials.schema';
export const listPartnerMaterialsContract = {
    method: 'GET',
    path: '/api/v2/partner/materials',
    description: 'List the active partner materials',
    responseSchema: ListPartnerMaterialsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not a partner tenant member'
        }
    }
};

//# sourceMappingURL=list-partner-materials.contract.js.map